module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/arrow-right-374f0a37dea38cf44ea73bbe1b1febf4.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/arrow-right.svg
// module id = r2C5
// module chunks = 24